<template>
  <div class="flex flex_between">
	  <md-button class="md-blank" @click="autoGenerateRates">
		  <i class="fa fa-magic" aria-hidden="true"></i>
		  {{ $t('seller.upload.installmentContract.autoRates.generateButton') }}
	  </md-button>
	  <el-dropdown @command="(command) => command()">
		  <md-button class="md-blank">
			  {{ $t("common.allSelected") }}<i class="el-icon-arrow-down el-icon--right"></i>
		  </md-button>
		  <el-dropdown-menu slot="dropdown">
			  <el-dropdown-item v-for="(item, index) in actionList"
								:key="index"
								:command="item.command"
								:disabled="item.disabled"
			  >
				  <i :class="item.icon"></i>
				  {{ item.text }}
			  </el-dropdown-item>
		  </el-dropdown-menu>
	  </el-dropdown>
  </div>
</template>
<script>
import {enumDef} from "@/common/enumDefs";

export default {
	props: {
		selectedRows: { type: Array, default: [] },
	},
	methods: {
		autoGenerateRates() {
			this.$emit("generate");
		},
		deleteAllSelected() {
			this.$emit("delete");
		},
	},
	computed: {
		actionList() {
			return [
				{
					command: this.deleteAllSelected,
					disabled: !this.deletable,
					icon: "fa fa-trash-o",
					text: this.$t("common.delete"),
				}
			];
		},
		deletable() {
			return this.selectedRows.some(row => {
				// todo installment: add MS condition when MS is allowed
				return enumDef.receivableStatus.isDeletable(row.status);
			});
		},
	}

};
</script>